@if (patched()) {
    <div class="container-fluid">
        <div class="row patch-box-details">
            <div
                class="col-12 d-flex justify-content-center align-items-center"
            >
                <div
                    class="d-flex justify-content-center align-items-center pt-4 pb-4 mt-2 mb-2"
                >
                    <div>
                        <i
                            class="fa-sharp-duotone fa-light fa-3x fa-object-exclude"
                        ></i>
                    </div>
                    <div class="d-flex flex-column">
                        <div class="font-lg ms-4">
                            Call Patched to {{ contactSelected.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
} @else {
    <div
        class="container-fluid d-flex flex-column enquiry-box-details ps-1 pt-2 pb-3 mb-2"
        [ngClass]="{ highlighted: panelHighlighted() !== 'enquiry' }"
    >
        <div class="row ps-3">
            <div class="col-1 p-0">
                <div class="rounded-circle call-initials mt-2 ms-2">
                    {{ contactSelected.name | initials }}
                </div>
            </div>
            <div class="col-10 ps-3">
                <div class="font-xxl weight-medium">
                    {{
                        contactSelected.type === 'agent'
                            ? 'Operator'
                            : contactSelected.identifier
                    }}&nbsp;{{ enquiryState() }}
                </div>
                <div class="font-lg">
                    {{ contactSelected.name }}
                </div>
                <div class="pt-1">
                    <span class="font-lg weight-normal text-secondary">
                        {{ enquiryTime() | formatDuration }}
                    </span>
                </div>
            </div>
            <div class="col-1 pt-1 text-center">
                <div
                    class="d-flex flex-column align-items-center h-100 justify-content-between me-3"
                >
                    <div>
                        <button
                            type="button"
                            class="btn btn-reject rounded-circle p-2"
                            (click)="endEnquiry()"
                            [class.disabled]="
                                enableButtons() || enquiryOnHold()
                            "
                        >
                            <i class="fa-xl fa-solid fa-phone-hangup"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-auto">
            <div class="row">
                <div class="col-4">
                    <div
                        tabindex="0"
                        class="btn-action p-3 w-100 text-center"
                        (click)="callCommand(gotoCommand())"
                        (keypress)="callCommand(gotoCommand())"
                        [ngClass]="{ 'disabled-btn': enableButtons() }"
                    >
                        <i class="fa-xl fa-light fa-shuffle ms-2 me-2"></i>
                        <span class="ms-2">{{ switchText() }}</span>
                    </div>
                </div>
                <div class="col-4">
                    <div
                        tabindex="1"
                        class="btn-action p-3 w-100 text-center"
                        (click)="callCommand(holdCommand())"
                        (keypress)="callCommand(holdCommand())"
                        [ngClass]="{
                            'disabled-btn': enableButtons() || holdDisabled(),
                        }"
                        [class.clicked]="enquiryOnHold()"
                    >
                        <i class="fa-xl fa-light fa-circle-pause ms-2 me-2"></i>
                        <span class="ms-2">{{ holdText() }}</span>
                    </div>
                </div>
                <div class="col-4">
                    <div
                        tabindex="2"
                        class="btn-action p-3 w-100 text-center"
                        (click)="callCommand('Patch')"
                        (keypress)="callCommand('Patch')"
                        [ngClass]="{ 'disabled-btn': enableButtons() }"
                    >
                        <i
                            class="fa-xl fa-light fa-object-exclude ms-2 me-2"
                        ></i>
                        <span class="ms-2">Patch Call</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
